const NON_WORKFLOW_PAGES = ['home', 'login', 'userauth', 'landing', 'prodstart'];
const WORKFLOW_PAGES = [];

export { NON_WORKFLOW_PAGES, WORKFLOW_PAGES };
